import { OBLIGATION_ENUM } from './OBLIGATION_ENUM'

export const GET_OBLIGATION_OPTIONS = [
  { id: OBLIGATION_ENUM.INCLUDE, name: 'Include' },
  { id: OBLIGATION_ENUM.NO_ACTION, name: 'No Action' },
]
